const burgerMenu = () => {
    const burgerMenu = document.querySelector(".burger-menu");
    const burgerOpen = document.querySelectorAll(".js-open-burger");
    const burgerClose = document.querySelectorAll(".js-close-burger");
    for (var i = 0; i < burgerOpen.length; i++) {
        burgerOpen[i].addEventListener("click", function(e){
            if (burgerMenu) {
                burgerMenu.classList.add("open");
            }
        });
    }
    for (var i = 0; i < burgerClose.length; i++) {
        burgerClose[i].addEventListener("click", function(e){
            if (burgerMenu) {
                burgerMenu.classList.remove("open");
            }
        });
    }
}
export default burgerMenu;
